/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_Body_Photo_WordsInputs */

const en_us2_search_field_body_photo_words = /** @type {(inputs: Search_Field_Body_Photo_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`photo photos camera body fat composition estimate waist`)
};

const pt_br2_search_field_body_photo_words = /** @type {(inputs: Search_Field_Body_Photo_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`foto fotos camera gordura composicao corporal estimativa cintura`)
};

const es_419_search_field_body_photo_words = /** @type {(inputs: Search_Field_Body_Photo_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`foto fotos camara grasa composicion corporal estimacion cintura`)
};

const pt_pt2_search_field_body_photo_words = /** @type {(inputs: Search_Field_Body_Photo_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`foto fotos camara gordura composicao corporal estimativa cintura`)
};

const fr_fr2_search_field_body_photo_words = /** @type {(inputs: Search_Field_Body_Photo_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`photo photos camera graisse composition corporelle estimation taille tour`)
};

const de_de2_search_field_body_photo_words = /** @type {(inputs: Search_Field_Body_Photo_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`foto fotos kamera körperfett zusammensetzung schätzung taille`)
};

const it_it2_search_field_body_photo_words = /** @type {(inputs: Search_Field_Body_Photo_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`foto fotocamera grasso composizione corporea stima vita`)
};

/**
* | output |
* | --- |
* | "photo photos camera body fat composition estimate waist" |
*
* @param {Search_Field_Body_Photo_WordsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_body_photo_words = /** @type {((inputs?: Search_Field_Body_Photo_WordsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_Body_Photo_WordsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_body_photo_words(inputs)
	if (locale === "es-419") return es_419_search_field_body_photo_words(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_body_photo_words(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_body_photo_words(inputs)
	if (locale === "de-DE") return de_de2_search_field_body_photo_words(inputs)
	if (locale === "it-IT") return it_it2_search_field_body_photo_words(inputs)
	return en_us2_search_field_body_photo_words(inputs)
});
export { search_field_body_photo_words as "search.field_body_photo_words" }